import { Container } from "react-bootstrap";

const partners = [
	{ href: "https://dopple.nl/", src: "/images/logos/DoppleLogo.png", alt: "Dopple" },
	{ href: "/", src: "/images/logos/EarsOnlyLogo.png", alt: "EarsOnly" },
	{ href: "https://reduson.nl/", src: "/images/logos/RedusonLogo.png", alt: "Reduson" },
];

export default function Mission() {
	return (
		<Container className="eo-mission">
			<p className="eo-section__overline">Who we are</p>
			<div className="eo-mission__grid">
				<h2 className="eo-section__title">EarsOnly builds on the combined expertise of Dopple and Reduson in wearable technology and Custom-Fit hearing protection.</h2>
				<div className="eo-mission__body">
					<p>
						Our mission is to protect hearing without compromising comfort, performance, or usability. We specialize in Custom-Fit hearing protection solutions designed to perform in the most demanding environments.
					</p>
					<p>Together, our solutions deliver trusted hearing protection, engineered for real-world performance. All day. Every day.</p>
					<a className="eo-mission__dopple" href="https://dopple.nl/" target="_blank" rel="noreferrer">
						<img src="/brand/powered-by-dopple-white.svg" alt="Powered by Dopple" loading="lazy" />
					</a>
				</div>
			</div>
			<div className="eo-mission__logos">
				{partners.map((p) => (
					<a key={p.alt} href={p.href} target="_blank" rel="noreferrer">
						<img src={p.src} alt={p.alt} loading="lazy" />
					</a>
				))}
			</div>
		</Container>
	);
}
